import { render, staticRenderFns } from "./RegionBanner.vue?vue&type=template&id=ad04a7bc&"
import script from "./RegionBanner.vue?vue&type=script&lang=ts&"
export * from "./RegionBanner.vue?vue&type=script&lang=ts&"
import style0 from "./RegionBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports